import React, { useEffect } from "react";
import { CriticalParametersList } from "../list/list";
import { logEvent } from "@shared/analytics/analytics";

const Landing = () => {
  useEffect(() => {
    logEvent("critical_parameters_landing_viewed");
  }, []);
  return (
    <div className="p-3">
      <div className="space-y-6">
        <div className="space-y-2">
          <p className="page-title">Critical Parameters</p>
          <p className="page-subtitle">
            Define the criteria and their relative importance (weightage) used
            to assess the criticality of assets.
          </p>
        </div>

        <CriticalParametersList />
      </div>
    </div>
  );
};

export default Landing;
